// extracted by mini-css-extract-plugin
module.exports = {"canvas":"Confetti_canvas__qR1xI"};